import {MSCQ_SELECT_OPTION, MSCQ_SUBMIT_ANSWER} from '../../Redux.constants';
import {
  submitQuestionAnswer,
  selectCheckboxOption,
} from './helper';

export function MSCQReducer(state = {}, action) {
  switch (action.type) {
    case MSCQ_SELECT_OPTION:
      return selectCheckboxOption(state, action.payload);
    case MSCQ_SUBMIT_ANSWER:
      return submitQuestionAnswer(state, action.payload);
    default:
      return state;
  }
}
